export default __webpack_public_path__ + "static/media/checked-handv.5ffe656e.svg";